enum ChefForPartyCancellationReasons {
    CHANGED_IN_PARTY_PLAN = "Changed in party plan",
    PRICING_ISSUE = "Pricing issue",
    FOUND_ANOTHER_ALTERNATIVE = "Found another alternative",
    OTHERS = "Other"
}

export default ChefForPartyCancellationReasons
